import SvgCheckboxEmpty from 'assets/pricing/checkbox-empty.inline.svg';
import SvgQuestionMark from 'assets/pricing/question-mark.inline.svg';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';

export default function HelperBox() {
	const { t } = useTranslation();

	return (
		<div style={{ maxWidth: '75rem' }} className='border-2 border-grey-E rounded-10 mt-40 sm:mt-20 mx-15 xl:mx-auto bg-light'>
			<div className='sm:flex items-center p-15'>
				<SvgQuestionMark />

				<div className='sm:ml-20 mt-15 sm:mt-0'>
					<div className='flex items-center mb-05'>
						<span className='text-20 text-dark leading-10 -mb-08'>*</span>
						<p className='leading-12 text-grey-7 ml-07'>{t('pagePricing.helper.1')}</p>
					</div>
					<div className='flex items-center'>
						<span><SvgCheckboxEmpty /></span>
						<p className='leading-12 text-grey-7 ml-07'>{t('pagePricing.helper.2')}</p>
					</div>
				</div>
			</div>
		</div>
	);
}
